import { stateURL } from "../../config/config"
import axiosInterceptor from "../axiosInterceptor/axiosInterceptor"

export const getAllState = async () => {
    try {
        const response = await axiosInterceptor().get(`${stateURL}/get/all`)
        return response

    } catch (error) {
        console.log(error)
    }
}

export const getAllStateByCountry = async (id) => {
    try {
        const response = await axiosInterceptor().get(`${stateURL}/getAllStateByCountry/${id}`)
        return response

    } catch (error) {
        console.log(error)
    }
}